<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12" style="border-bottom: 2px solid black">
      {{ translate("saved.searchprofiles") }}
    </div>
    <div class="p-col-12" style="min-height: 555px; padding: 0px">
      <DataTable
          :scrollable="true"
          :selection.sync="searchProfileSelection"
          :value="getSearchProfiles"
          class="profile-table"
          dataKey="id"
          scroll-height="500px"
          selectionMode="single"
      >
        <Column>
          <template #body="slotProps">
            <div class="centered-left">
              <template v-if="isProfileActive(slotProps.data)">
                <b
                ><i>{{ slotProps.data.profileName }}</i></b
                >
              </template>
              <template v-else>
                {{ slotProps.data.profileName }}
              </template>
              <i v-if="slotProps.data.published" class="pi pi-users"></i>
            </div>
            <div class="centered-right">
              <Button
                  :disabled="!authorized(slotProps.data)"
                  class="p-button-secondary"
                  icon="pi pi-angle-down"
                  v-on:click="searchProfileClick(slotProps.data, $event)"
              ></Button>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
    <div class="p-col-12">
      <Button
          :label="translate('button.replace.search')"
          v-on:click="loadSearchProfile"
      ></Button>
    </div>

    <ContextMenu ref="menu" :model="items" :visible="true"></ContextMenu>
    <Dialog
        :header="translate('header.delete.confirmation')"
        :modal="true"
        :style="{ width: '50vw' }"
        :visible.sync="deleteDialog"
    >
      {{ translate("would.you.delete.the.profile") }}
      <span v-if="clickedProfile != null">
        {{ clickedProfile.profileName }}</span
      >
      <template #footer>
        <Button
            :label="translate('button.delete')"
            class="p-button-danger"
            icon="pi pi-trash"
            @click="deleteConfirmation"
        />
        <Button
            :label="translate('button.cancel')"
            class="p-button-secondary"
            icon="pi pi-times"
            @click="deleteDialog = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TranslateService from "../services/translate.service";

export default {
  name: "SearchProfiles",
  data() {
    return {
      searchProfileSelection: null,
      items: [
        {
          label: "Publish",
          icon: "pi pi-users",
          command: () => {
            this.publishClick();
          },
        },
        {
          label: "Depublish",
          icon: "pi pi-user",
          command: () => {
            this.dePublishClick();
          },
        },
        {
          separator: true,
        },
        {
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.deleteProfileClick();
          },
        },
      ],
      clickedProfile: null,
      deleteDialog: false,
    };
  },
  computed: {
    ...mapGetters("search", ["getSearchProfiles", "getActiveProfile"]),
    ...mapGetters('config', ['isAdmin'])
  },
  methods: {
    ...mapActions("search", [
      "loadSearchProfiles",
      "activateSearchProfile",
      "removeProfile",
      "publishProfile",
      "dePublishProfile",
    ]),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    deleteProfileClick() {
      this.deleteDialog = true;
    },
    deleteConfirmation() {
      this.removeProfile(this.clickedProfile.id);
      this.deleteDialog = false;
    },
    publishClick() {
      this.publishProfile(this.clickedProfile.id);
    },
    dePublishClick() {
      this.dePublishProfile(this.clickedProfile.id);
    },
    loadSearchProfile() {
      this.activateSearchProfile(this.searchProfileSelection);
    },
    searchProfileClick(item, event) {
      this.clickedProfile = item;
      this.$refs.menu.show(event);
    },
    isProfileActive(profile) {
      if (this.getActiveProfile == null) {
        return false;
      }
      return this.getActiveProfile.id === profile.id;
    },
    authorized(profile) {
      return profile.owner || this.isAdmin;
    }
  },
  mounted() {
    this.loadSearchProfiles();
  },
};
</script>

<style scoped></style>
